import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild
} from '@angular/core';
import {debounceTime, distinctUntilChanged, fromEvent, map, Subscription, tap} from "rxjs";

require('./bringoz-file-download-button.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-file-download-button',
  templateUrl: './bringoz-file-download-button.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozFileDownloadButtonComponent {

  @Input() url: string;
  @Input() description: string;


  downloadFile() {
    let downloadUrl = this.url;
    let a = document.createElement("a");
    a.href = downloadUrl;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }

}
